export default "__VITE_ASSET__DYH8SMuV__"